import ValidateSelectList from "../rules/selectList";

const FormSelectItemValidation = (value) => {
  return ValidateSelectList(value);
};

export default FormSelectItemValidation;



// WEBPACK FOOTER //
// ./src/components/validation/forms/formSelectItemValidation.js